import React, { useCallback, FormEvent, useState, useEffect, useRef } from 'react'
import { motion } from "framer-motion"
import { Link } from 'react-router-dom'
import styles from './Callback.module.scss'
import  emailjs  from  '@emailjs/browser'
import { FormValidation } from '../../hooks/FormValidation'
import InputMask from "react-input-mask"
import wp from '../../image/Callback/wp.svg'
import tg from '../../image/Callback/tg.svg'

const boxAnimation = {
    hidden: {
        x: -500,
        opacity: 0,
    },

    visible: {
        x: 0,
        opacity: 1,
        transition: { duration: .6 }
    }
}

const formAnimation = {
    hidden: {
        x: 500,
        opacity: 0,
    },

    visible: {
        x: 0,
        opacity: 1,
        transition: { duration: .6 }
    }
}


export const Callback = ({popupOpen}:any) => {

    const handleForm:any = FormValidation()
    const [buttonDisabled, setButtonDisabled] = useState<boolean>(true)
    const form:any = useRef()

    useEffect(() => {
        handleForm.isValid ? setButtonDisabled(false) : setButtonDisabled(true)
    }, [handleForm.isValid])

    const sendData = useCallback((evt:FormEvent<HTMLFormElement>) => {
        evt.preventDefault();
            emailjs.sendForm('service_jyvramd', 'template_45xjdbf', form.current, 'ypJeFxyaiNsyaBjPV')
            .then((result) => {
            }, (error) => {
                console.log(error.text);
            }); 
        handleForm.resetForm()
        popupOpen()
    }, [handleForm, popupOpen] )


    return (
        <motion.div 
            className={styles.container_form}
                initial='hidden'
                whileInView='visible'
                viewport={{amount: 0.3, once: true}}
                >
                <motion.div className={styles.box} variants={boxAnimation}>
                    <h2 className={styles.title}>Обсудить <span>проект</span></h2>
                    <p className={styles.text}>Если у Вас остались вопросы, напишите мне в Telegram, WhatsApp, или заполните форму обратной связи</p>
                    <div className={styles.list}>
                            <a className={styles.link} target='_blank' rel='noopener noreferrer' href='https://api.whatsapp.com/send?phone=79258898545' aria-label='связаться вацап'>
                                <img src={wp} alt="Whatsapp"/>
                                <span>Whatsapp</span>
                            </a>
                            <a className={styles.link_telegram} target='_blank' rel='noopener noreferrer' href='https://t.me/Dmitry_Tihonoff' aria-label='телеграмм'>
                                <img src={tg} alt="Whatsapp"/>
                                <span>telegram</span>
                            </a>
                    </div>
                </motion.div>
                <motion.form className={styles.form} onSubmit={sendData} ref={form}  variants={formAnimation}>
                    <div className={styles.box_input}>
                        <label className={styles.label}>Введите имя
                            <input
                                className={`${styles.input} ${handleForm.errors.name && styles.wrong}`}
                                type='text' 
                                name='name'
                                value={handleForm.values.this}
                                onChange={handleForm.handleChange} 
                                pattern='^[A-Za-zА-Яа-яЁё\s\-]{2,30}$'
                                required/>
                        </label>
                    </div>
                    <span className={styles.input_error}>{handleForm.errors.name}</span>
                    <div className={styles.box_input}>
                        <label className={styles.label}>Введите телефон      
                            <InputMask
                                className={`${styles.input} ${handleForm.errors.phone && styles.wrong}`}
                                type='tel' 
                                name='phone'
                                value={handleForm.values.this}
                                onChange={handleForm.handleChange}
                                mask={'+7\\(999) 999-99-99'}  
                                required/>
                        </label>
                    </div>
                    <span className={styles.input_error}>{handleForm.errors.phone}</span> 
                    <div className={styles.box_textarea}>
                        <label className={styles.label_textarea}>Комментарий
                            <textarea
                                    className={`${styles.textarea} ${styles.scrollbar}`}
                                    name='comment'
                                    value={handleForm.values.this}
                                    onChange={handleForm.handleChange}/>       
                        </label>
                    </div>                
                            <button className={`${styles.button_form} ${buttonDisabled && styles.button_disabled}`}type='submit'><span>Отправить</span></button>
                            <p className={styles.text_form}>*Нажимая «Отправить», вы соглашаетесь с <Link  className={styles.link_form} to='/politika-konfidencialnosti'>&#8194;политикой конфиденциальности.</Link></p>
                </motion.form>
            </motion.div> 
    )
}